@use "@fukuri-admins/ui/layout" as *;

.root {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 8px;
  border-radius: 6px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  svg {
    color: currentColor;
  }
  &.small {
    font-size: 13px;
    &.noIcon {
      padding: 4px 12px;
    }
    &.iconLeft {
      padding: 4px 12px 4px 8px;
    }
    &.iconRight {
      padding: 4px 8px 4px 12px;
    }
  }
  &.medium {
    font-size: 14px;
    min-height: 40px;
    &.noIcon {
      padding: 8px 20px;
    }
    &.iconLeft {
      padding: 8px 20px 8px 12px;
    }
    &.iconRight {
      padding: 8px 12px 8px 20px;
    }
  }
  &.large {
    font-size: 16px;
    border-radius: 8px;
    &.noIcon {
      padding: 12px 24px;
    }
    &.iconLeft {
      padding: 12px 24px 12px 16px;
    }
    &.iconRight {
      padding: 12px 16px 12px 24px;
    }
  }
  &.darkFill {
    background: $Button;
    color: #fff;
    &:hover {
      background: $ButtonHover;
    }
  }
  &.darkOutline {
    background: $White;
    border: 1px solid $Button;
    color: $Button;
    &:hover {
      background: $ButtonHover;
    }
  }
  &.lightFill {
    background: $ButtonLightGray;
    &:hover {
      background: $ButtonLightGrayHover;
    }
  }
  &.whiteFill {
    background: $White;
    &:hover {
      background: $WhiteHover;
    }
  }
  &.redFill {
    background: $ButtonRed;
    &:hover {
      background: $ButtonRedHover;
    }
  }
  &.redOutline {
    background: $White;
    border: 1px solid $ButtonRed;
    color: $ButtonRed;
    &:hover {
      background: $ButtonRedOutlineHover;
    }
  }

  @media (max-width: 540px) {
    padding: 12px 24px;
    p {
      font-size: 12px;
    }
  }
  @media (max-width: 400px) {
    padding: 8px 10px;
    p {
      font-size: 10px;
    }
  }
}

.description {
  font-family: "Noto Sans JP";
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  word-break: keep-all;
  line-height: 1;
  &.darkFill {
    color: $White;
  }
  &.darkOutline,
  &.lightFill {
    color: $Text;
  }
}

.disable {
  opacity: 0.7;
  cursor: no-drop;

  &:hover {
    box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.2) !important;
    transform: translate(0px, 0px) !important;
  }
}

.noDisable {
  opacity: 1;
}
